import { combineReducers } from 'redux';

import user from './user/reducer';
import language from './language/reducer';
import accesslevel from './accesslevel/reducer';
import translate from './translate/reducer';
import permission from './permission/reducer';
import magictools from './magictools/reducer';

import unit from './unit/reducer';
import lesson from './lesson/reducer';
import course from './course/reducer';
import company from './company/reducer';
import useronline from './useronline/reducer';
import chat from './chat/reducer';
import classroom_option from './clasroom_option/reducer';
import badge from './badge/reducer';
import gamification from './gamification/reducer';

export default combineReducers({classroom_option,chat,user,language,accesslevel,translate,permission,magictools,unit,lesson,course,company,useronline,badge,gamification});